import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=4166fdb6&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4166fdb6",
  null
  
)

export default component.exports